// extracted by mini-css-extract-plugin
export default {"page":"DaDgea8BjxiFgNYAma8a","back":"ho3opMWDCubhsRtJVeVL","content":"Db7SBOQpgB3EWVoQnV1W","pulse":"KpaUGiC7slBQKK3G4uY0"};